import { DEFAULT_TYPES } from 'constants/DefaultSources';

export const DEFAULT_FILTERS_VIEW_OPTIONS = {
  MY_DEFAULTS: DEFAULT_TYPES.MY_DEFAULTS,
  ORG_DEFAULTS: DEFAULT_TYPES.ORGANIZATION_DEFAULTS,
  TEAM_DEFAULTS: DEFAULT_TYPES.TEAM_DEFAULTS,
  MY_VIEWS: 'My views',
  CORPORATE: 'Corporate'
};
